import { allGraphs } from "../config";
import initializeBatterySolar from "../panels/graphs/batterycharge_solarchargerate";
import initializeTemperatureHumidity from "../panels/graphs/temperature_humidity";
import initializeWindRose from "../panels/graphs/windroses";
import initializeSolarPower from "../panels/graphs/sunlighthours_energy";
import initializeTargetAltitudes from "../panels/graphs/target_altitudes";
import initializeCloudiness from "../panels/graphs/cloudiness";
import initializeSolarEnergy from "../panels/graphs/solaraltitude_chargerate";

/**
 * Function to call in initialize.js to refresh graphs
 */
export function refreshGraphs() {
  allGraphs.forEach((func) => {
    try {
      func();
    } catch (err) {
      console.log(`Error in Refreshing Graph: ${err}`);
    }
  });
}

/**
 * Function to call once, during first setup
 */
export async function initializeGraphs() {
  const promiseList = [
    initializeBatterySolar(),
    initializeTemperatureHumidity(),
    initializeWindRose(),
    initializeSolarPower(),
    initializeTargetAltitudes(),
    initializeSolarEnergy(),
    initializeCloudiness(),
  ];

  await Promise.allSettled(promiseList).then((results) => {
    results.forEach((result) => {
      if (result.status == "fulfilled") {
        allGraphs.push(result.value);
      } else {
        console.log(result.reason);
      }
    });
  });

  return null;
}
